import { useEffect, useState } from "react";
import { Logo } from "../shared/components/Logo";
import { Text, Stack, Center, Paper, Box } from "@mantine/core";
import { useSearch } from "wouter";

const WaitForLoginEmail = () => {
  const search = useSearch();
  const [email, setEmail] = useState("");
  const [isPersonalizedLogin, setIsPersonalizedLogin] = useState(false);
  useEffect(() => {
    setEmail(window.localStorage.getItem("emailForSignIn") ?? "");
  }, []);

  useEffect(() => {
    // Allows navigation from elsewhere, like from an email link
    const queryParams = new URLSearchParams(search);
    const source = queryParams.get("source") ?? "";
    if (source === "personalizedLogin") {
      setIsPersonalizedLogin(true);
    }
  }, [search, location]);
  return (
    <Center style={{ height: "100vh" }}>
      <Stack align="center" justify="center" gap="sm">
        <Box w={100}>
          <Logo />
        </Box>
        <Text size="lg" ml="xl" mr="xl">
          A login link has been sent to <strong>{email}</strong>. Make sure that
          your email address is correct.
        </Text>
        {isPersonalizedLogin && (
          <Text mt="md" ml="xl" mr="xl">
            Check your email (including spam/junk just in case) for the login
            link.
          </Text>
        )}
        {!isPersonalizedLogin && (
          <Text mt="md" ml="xl" mr="xl">
            Check your email (including spam/junk just in case) for the login
            link. If not found, go back to the login page and register by either
            clicking the Register button or by logging in with Google.
          </Text>
        )}
        <Paper>You may close this page.</Paper>
      </Stack>
    </Center>
  );
};

export default WaitForLoginEmail;
